import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { UserManager } from 'oidc-client-ts';
import { handleError } from 'services/ErrorService/ErrorService';
import { useHistory } from 'react-router-dom';
import { getSSOConfig, getPreLoginEmail } from '../../../selectors/auth';
import { hasDomain } from '../../../util';
import * as AuthServiceModule from '@asurion-core/frontend-utils/lib/AuthService';
import environment from '../../../environment';

export default function useSSOLogin() {
  const [error, setError] = useState('');
  const [disabled, setDisabled] = useState(false);
  const [loading, setLoading] = useState(true);

  const history = useHistory();
  const ssoConfig = useSelector(getSSOConfig);
  const preLoginEmail = useSelector(getPreLoginEmail);
  const isPartner = ssoConfig?.userType === AuthServiceModule.USER_TYPE.PARTNER;

  useEffect(() => {
    if (!preLoginEmail || !ssoConfig) {
      history.push('/');
    }

    if (!ssoConfig?.enableSSO) {
      history.push('/login');
    }

    setLoading(false);
  }, [preLoginEmail, ssoConfig, history]);

  const signIn = async () => {
    try {
      if (!ssoConfig?.oidcConfig || !ssoConfig.enableSSO) {
        throw new Error('SSO is not enabled for this user');
      }

      // TODO(pavlozaporozkyi|SPD-11399|2024-12-6): Make this more configurable
      //  If it's needed. Right now we only have one special case for one domain
      //  But there might be other cases in the future for other domains or other IDPs
      const isAsurionUser = hasDomain(preLoginEmail, 'asurion.com');

      const extraQueryParams = {
        ...(ssoConfig.oidcConfig.extraQueryParams || {}),
      };

      if (!isAsurionUser) {
        extraQueryParams.login_hint = preLoginEmail;
      }

      const manager = new UserManager({
        ...ssoConfig.oidcConfig,
        ...(environment.auth?.ssoRedirectUri && { redirect_uri: environment.auth.ssoRedirectUri }),
        extraQueryParams,
      });

      await manager.signinRedirect();
    } catch (err) {
      let errorMessage = typeof err.message === 'string' ? err?.message : err?.message?.message;

      if (!errorMessage) {
        errorMessage = 'Login failed';
      }

      setError(errorMessage);
      setDisabled(true);

      handleError({ error: err });
    }
  };

  return {
    error,
    disabled,
    loading,
    preLoginEmail,
    signIn,
    ssoConfig,
    isPartner,
  };
}
